import { DefaultService } from '@/services/DefaultService';

export default class LicencaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(marca) {
        return this._http.post(`${this._env}/product/licence`, marca, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/product/licence/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/product/licence/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50,situacao = 2, order = 'asc', column = 'descricao',...params) {
        return this._http.get(encodeURI(`${this._env}/product/licence.json?page=${page}&limit=${limit}&situacao=${situacao}&order=${order}&column=${column}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(licenca) {
        return this._http
            .post(
                `${this._env}/product/licence/updatesituacao`,
                licenca,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }


}